<template>
  <VModalWidget :dismiss="dismiss" :submit="doSubmit" :submitting="submitting" :submitTitle="this.$t('create')">
    <template slot="title">{{ $t('title') }}</template>

    <template slot="content">
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-form>
        <v-text-field
          v-model.trim="form.display"
          :label="$t('displayName')"
          :error-messages="nameErrors"
          required
          @input="$v.form.display.$touch()"
          @blur="$v.form.display.$touch()"
          v-on:keyup.enter="doSubmit"
        />
        <v-select
          v-model="form.template_id"
          :items="templates"
          item-text="display"
          item-value="id"
          :label="$t('template')"
          :error-messages="templateIdErrors"
          required
          @blur="$v.form.template_id.$touch()"
        />
        <v-text-field v-model.trim="form.description" :label="$t('description')" v-on:keyup.enter="doSubmit" />
      </v-form>
    </template>
  </VModalWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { Modal } from '@argon/app/mixins'
import { BaseForm, FormErrors, VModalWidget } from '@argon/app/components'
import { NAMESPACE } from '../store'

export default {
  name: 'modal-new-flow',
  extends: BaseForm,
  mixins: [Modal],
  props: {
    returnLink: { type: String, default: 'flows' }
  },
  components: {
    VModalWidget,
    FormErrors
  },
  validations: {
    form: {
      display: { required },
      template_id: { required },
      description: {}
    }
  },
  data() {
    return {
      returnPath: { name: this.returnLink, params: this.$route.params },
      form: {
        display: '',
        template_id: '',
        description: ''
      },
      submitting: false
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['flows', 'templates']),
    nameErrors() {
      const errors = []
      if (!this.$v.form.display.$dirty) return errors
      !this.$v.form.display.required && errors.push(this.$t('required'))
      this.getServerErrors('display', errors)
      return errors
    },
    templateIdErrors() {
      const errors = []
      if (!this.$v.form.template_id.$dirty) return errors
      !this.$v.form.template_id.required && errors.push(this.$t('required'))
      this.getServerErrors('template_id', errors)
      return errors
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['listTemplates', 'clearTemplates', 'createFlow']),
    doSubmit() {
      if (this.$v.form.$invalid) {
        return this.$v.form.$touch()
      }
      this.submitting = true
      this.createFlow(this.form)
        .then((resp) => {
          this.dismiss()
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.submitting = false
        })
    },
    fetchData() {
      this.listTemplates().catch(() => {})
    }
  },
  created() {
    this.fetchData()
  },
  destroyed() {
    this.clearTemplates()
  }
}
</script>

<i18n>
{
  "en": {
    "create": "@:labels.create",
    "description": "@:labels.description",
    "displayName": "@:labels.displayName",
    "required": "@:labels.required",
    "save": "@:labels.save",
    "template": "@:labels.template",
    "title": "New Flow"
  },
  "fr": {
    "create": "@:labels.create",
    "displayName": "@:labels.displayName",
    "required": "@:labels.required",
    "save": "@:labels.save",
    "template": "@:labels.template",
    "title": "Nouveau flux"
  }
}
</i18n>
